import ActionItem from "./ActionItem";
export default function ActionItemsList({
  title,
  action_type,
  itemsList,
  setActiveActionItem,
  openAddActionItemModal,
}) {


  return (
    <div className="w-[25%] h-full border-solid border-r-2 border-slate-100 p-2 last:border-none">
      {itemsList.length > 0 ? (
        itemsList
          .filter(
            (item) =>
              item?.actionType &&
              parseInt(item?.actionType) === parseInt(action_type)
          )
          .map((item) => (
            <ActionItem
              key={item.pk ?? item.id}
              item={item}
              columnType={action_type}
              setActiveActionItem={setActiveActionItem}
              openAddActionItemModal={openAddActionItemModal}
            />
          ))
      ) : (
        <div className="w-full text-center text-xs text-gray-600 capitalize rounded-lg bg-gray-100 p-1">
          No items to show
        </div>
      )}
    </div>
  );
}
